import { useId } from 'react';
import { cx } from '../internal/tone';
import { FieldShell, describedBy } from './Field';

export interface TextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  hint?: string;
  required?: boolean;
  multiline?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  /** Sugestão de teclado no Android: 'email', 'tel', 'numeric'… */
  inputMode?: 'text' | 'email' | 'tel' | 'url' | 'search' | 'numeric' | 'decimal';
  disabled?: boolean;
  name?: string;
  rows?: number;
}

export function TextField({
  label,
  value,
  onChange,
  error,
  hint,
  required = false,
  multiline = false,
  autoFocus = false,
  placeholder,
  inputMode,
  disabled = false,
  name,
  rows = 4,
}: TextFieldProps) {
  const base = useId();
  const id = `${base}-input`;
  const hintId = `${base}-hint`;
  const errorId = `${base}-error`;

  const shared = {
    id,
    name,
    value,
    disabled,
    placeholder,
    required,
    autoFocus,
    'aria-invalid': error ? (true as const) : undefined,
    'aria-describedby': describedBy(hint, hintId, error, errorId),
    className: cx('flos-input', multiline && 'flos-input--multiline', error && 'flos-input--invalid'),
  };

  return (
    <FieldShell
      id={id}
      label={label}
      required={required}
      hint={hint}
      hintId={hintId}
      error={error}
      errorId={errorId}
    >
      {multiline ? (
        <textarea
          {...shared}
          rows={rows}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input
          {...shared}
          type="text"
          inputMode={inputMode}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </FieldShell>
  );
}
